<template>
  <section
    id="website"
    v-infinite-scroll="fetchWebsites"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="200"
  >
    <div class="section padding-page-top padding-bottom over-hide">
      <div class="container ">
        <div class="row page-title px-4 px-xl-2">
          <div class="col-12 parallax-fade-top">
            <h1>Websites</h1>
          </div>
          <div class="offset-1 col-11 parallax-fade-top mt-2 mt-sm-3">
            <p>A collection of websites I've built</p>
          </div>
        </div>
      </div>
    </div>

    <div class="section padding-bottom-big over-hide">
      <div class="container websites-grid">
        <PageCard
          v-for="(website, index) in websites"
          :key="index"
          :page="website"
        />
      </div>
    </div>

    <h6 class="text-center" style="opacity: 0.2">
      That's All Folks
    </h6>
  </section>
</template>

<script>
import { EventBus } from "../main";
import { ParallaxEffect } from "@/components/utils";
import { mapGetters, mapActions } from "vuex";
import infiniteScroll from "vue-infinite-scroll";
import PageCard from "@/components/PageCard";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({ busy: "websites/busy", websites: "websites/websites" })
  },
  methods: {
    ...mapActions({ fetchWebsites: "websites/fetchWebsites" })
  },
  components: {
    PageCard
  },
  directives: { infiniteScroll },
  mounted() {
    EventBus.$emit(
      "allLinks",
      document.querySelectorAll("a, button, .page__searchbar")
    );
    ParallaxEffect(this.$el);
  }
};
</script>

<style lang="scss" scoped>
.websites-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-auto-flow: dense;
  grid-gap: 2rem;
  transition: 0.3s all ease;

  @media (min-width: 794px) {
    grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
  }
}
</style>
